import React from 'react';
import AdvertisingForm from '../components/advertising/AdvertisingForm';
import './Advertising.css';
import Seo from '../components/Seo';
import { SiteHeader, SiteFooter } from '../components/SiteChrome';

export default function Advertising() {
  return <div className="f1000-site Advertising-page"><Seo title="Work with First 1000" description="Sponsor First 1000: honest notes on building products, growth, and the journey behind Lazyweb." canonical="https://www.first1000.co/advertise"/><SiteHeader/><main id="main" className="Advertising-page-main"><AdvertisingForm/></main><SiteFooter/></div>;
}
